import { Action } from '@ngrx/store';
import { PromoViewEvent, PromoClickEvent } from '@vestiaire/vc-angular-lib/lib/page/track-block';

export enum PromoActionsTypes {
  PROMO_VIEW = '[Promo] block viewed',
  PROMO_CLICKED = '[Promo] block clicked'
}

export class PromoViewed implements Action {
  readonly type = PromoActionsTypes.PROMO_VIEW;
  constructor(public payload: PromoViewEvent) {}
}

export class PromoClicked implements Action {
  readonly type = PromoActionsTypes.PROMO_CLICKED;
  constructor(public payload: PromoClickEvent) {}
}

export type PromoActions = PromoViewed | PromoClicked;
